module.exports = __webpack_public_path__ + "img/f-6-1.57a43f1e.png";